export const chase = false;
export const clouds = false;
export const zoomed = false;
export const cars = true;
export const night = false;
export const map = {
  rows: 15,
  coins: 3
}